__turbopack_context__.v({
  "appTheme": "FooterDesktop-module-scss-module__wNnm-q__appTheme",
  "bayernSection": "FooterDesktop-module-scss-module__wNnm-q__bayernSection",
  "footer": "FooterDesktop-module-scss-module__wNnm-q__footer",
  "impressumSection": "FooterDesktop-module-scss-module__wNnm-q__impressumSection",
  "medienSection": "FooterDesktop-module-scss-module__wNnm-q__medienSection",
  "newsletterSection": "FooterDesktop-module-scss-module__wNnm-q__newsletterSection",
  "rubrikenSection": "FooterDesktop-module-scss-module__wNnm-q__rubrikenSection",
  "socialSection": "FooterDesktop-module-scss-module__wNnm-q__socialSection",
});
